export const TABLE_PROMPT_MAX_SIZE = 10
export const TOOLBAR_CONTAINER_ID = 'neruda-toolbar-container'
export const MAIN_CONTENT_ID = 'main-content'
export const MAIN_COLUMN_CONTAINER_ID = 'main-column-container'
export const EDITOR_CONTAINER_ID = 'editor-container'
export const HIDDEN_INPUT_ID = 'hidden-input'
// TODO: Confirm this is not being used on Heap or FS or any other analytics tool and make it kebab cased like all others
export const MAIN_LEFT_COLUMN_ID = 'editorContentLeftColumn'
export const MAIN_RIGHT_COLUMN_ID = 'editor-content-right-column'
